import U from '../js/utils';
import svg from '../js/svg';

export default async ({msg, state}) => {
  // 0 = Success
  // 1 = Information
  // 2 = Error

  state = state ? state : 0;

  
  const toastID = await U.uuidvMain();
  const tickElement = await svg.tickCircle();
  const crossCircle = await svg.crossCircle();
  const tick = tickElement.outerHTML;
  const cross = crossCircle.outerHTML;

  const stateArr = ['Success', 'Information', 'Error'];
  const svgArr = [tick, tick, cross];


  const div = `
    <div id="${toastID}" class="toast">
      <div class="notification">
      <div>${svgArr[state]}</div>
      <div>${stateArr[state]}: ${msg}</div>
      </div>
    </div>
     `;

  let toastWindow;
  if (U.id('toastWindow')) {
    toastWindow = U.id('toastWindow');
  } else {
    toastWindow = U.divAtt('div', 'id', 'toastWindow');
    document.body.prepend(toastWindow);
  }

  const toast = U.createHTMLElementFromString(div);
  toastWindow.prepend(toast);

  // const toast = U.createHTMLElementFromString(div);
  // document.body.prepend(toast);

  setTimeout(() => {
    U.closeModal(toastID, 'toastWindow');
  }, 6000);
};

// return;

//  note(message) {
//   const un = this.uuidvMain();
//   const alertBanner = id("alertBanner");
//   const msg = message ? `- ${message}` : "";
//   const banner = this.divAtt("div", "class", "notification");
//   banner.setAttribute("id", `banner_${un}`);
//   const imgDiv = this.divAtt("div", "class", "");
//   const img = this.divAtt("div");
//   img.innerHTML = circleTickIcon;
//   const msgHdr = this.divAtt("div", "class", "");
//   msgHdr.innerHTML = `<p><strong>Success!</strong> ${msg}</p>`;
//   msgHdr.style.marginRight = "10px";
//   const btn = this.divAtt("div", "onclick", `hide('banner_${un}')`);
//   btn.innerHTML = "&#10005";
//   btn.style.color = "#747474";

//   imgDiv.appendChild(img);
//   banner.appendChild(imgDiv);
//   banner.appendChild(msgHdr);
//   banner.appendChild(btn);
//   alertBanner.appendChild(banner);
